import { render, staticRenderFns } from "./NewQueueStep2.vue?vue&type=template&id=124d8523&scoped=true&"
import script from "./NewQueueStep2.vue?vue&type=script&lang=js&"
export * from "./NewQueueStep2.vue?vue&type=script&lang=js&"
import style0 from "./NewQueueStep2.vue?vue&type=style&index=0&id=124d8523&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124d8523",
  null
  
)

export default component.exports